import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Link, Container, Typography } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';
import Logo from '../components/Logo';
// sections
import { LoginForm } from '../sections/auth/login';
import AuthSocial from '../sections/auth/AuthSocial';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const { REACT_APP_NAME } = process.env;

// ----------------------------------------------------------------------
//
export default function Login() {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle sx={{ display: { xs: 'block', md: 'none' }, marginTop: { sm: '50px' } }}>
          <Logo />



        </HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <Logo />
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5, display: 'flex', justifyContent: 'center' }}>
              Hi, Welcome Back
            </Typography>
            <img src="/static/illustrations/one.png" alt="login" />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            {/* <Typography variant="h4" gutterBottom textAlign={'center'}>
              Sign in to {REACT_APP_NAME}
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 5 }} textAlign={"center"}>Enter your details below.</Typography> */}

            {/* <AuthSocial /> */}



            <LoginForm />



          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
